export default __webpack_public_path__ + "static/media/lateral_b.56163ffd.jpg";